
// React Router v6+ compatible
const FullyPublicRoute = ({ element }) => {
    return element;
};

export default FullyPublicRoute;